// @flow
import React, { Component } from 'react';
import { CommissionRateCardDiv } from './CommissionRateInfoStyles';

type Props = {
  title: string,
  textOne: string,
  textTwo: ?string
};

export default class CommissionRateCard extends Component<Props> {
  render() {
    return (
      <CommissionRateCardDiv>
        <h5>{this.props.title}</h5>
        <p>{this.props.textOne}</p>
        <p>{this.props.textTwo}</p>
      </CommissionRateCardDiv>
    );
  }
}
